import React, {useEffect, useRef, useState}  from 'react';
import {BrowserRouter as Router, Routes, Route, useNavigate, useLocation, useInRouterContext} from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

//회원관련
import Login from "../screen/member/Login";
import Findid from "../screen/member/Findid";
import Findpw from "../screen/member/Findpw";

import Register0 from "../screen/member/Register0";
import Register from "../screen/member/Register";
import Register2 from "../screen/member/Register2";
import Storeselctor from "../screen/member/Storeselctor";
import Storetype1Write from "../screen/member/Storetype1Write";
import StoretypeFin from "../screen/member/StoretypeFin";
import StoretypeFinsub from "../screen/member/StoretypeFinsub";
import Storetype2Write from "../screen/member/Storetype2Write";

//홈
import Home from "../screen/home/Home";

//메인메뉴들
//import Main from "../screen/main/Main";
import Main from "../screen/main/MainNew"; // 새로운 홈
import Product from "../screen/product/Product";
import ItemDetails from "../screen/product/ItemDetails";
import Customersendlist from "../screen/product/Customersendlist";

import Customer from "../screen/customer/Customer";
import Schedules from "../screen/schedule/Schedules";
import Contract from "../screen/contract/Contract";
import Outsidelist from "../screen/outside/Outsidelist";

//마이페이지
import Mypage from "../screen/mypage/Mypage";
import Abortpage from "../screen/mypage/Abortpage";
import Favoritpage from "../screen/mypage/Favoritpage";
import Blacklists from "../screen/mypage/Blacklists";
import ApplicationList from "../screen/mypage/ApplicationList";
import CompanyNotice from "../screen/mypage/CompanyNotice";
import CompanyInfo from "../screen/mypage/CompanyInfo";
import CompanyCalc from '../screen/mypage/CompanyCalc';
import CompanyworkEnd from "../screen/mypage/CompanyworkEnd";
import Membercontrol from "../screen/mypage/Membercontrol";
import Contactus from "../screen/mypage/Contactus";
import Deletelist from "../screen/mypage/Deletelist";
import Setminihome from "../screen/mypage/Setminihome";
import Workstat from "../screen/mypage/Workstat";
import Workstatceo from "../screen/mypage/Workstatceo";
import Setoutside from "../screen/mypage/Setoutside";


//고객센터
import Noticelist from "../screen/customercenter/Noticelist";
import NoticeDetail from "../screen/customercenter/NoticeDetail";
import Faqlist from "../screen/customercenter/Faqlist";
import Useguidelist from "../screen/customercenter/Useguidelist";
import UseguidelistV from "../screen/customercenter/UseguidelistV";
import UseguideDetail from "../screen/customercenter/UseguideDetail";
import UseguideDetailV from "../screen/customercenter/UseguideDetailV";


//리뷰
import ReviewPage from "../screen/review/ReviewPage";


// 미니 홈피
import MiniPage from "../screen/miniPage/MiniPage";

// 커뮤니티
import Asking from "../screen/community/Asking";
import AskingContent from "../screen/community/AskingContent";
import JobSearchOfferBoard from "../screen/community/JobSearchOfferBoard";
import JobOffer from "../screen/community/JobOffer";
import JobBoardContent from "../screen/community/JobBoardContent";
import OfficeSalesBoard from "../screen/community/OfficeSalesBoard";
import OfficeSalesWrite from "../screen/community/OfficeSalesWrite";
import OfficeSalesDetail from "../screen/community/OfficeSalesDetail";
import LocationCommunity from "../screen/community/LocationCommunity";
import LocationCommunityWrite from "../screen/community/LocationCommunityWrite";
import LocationCommunityContent from "../screen/community/LocationCommunityContent";
import GatheringBoard from "../screen/community/GatheringBoard";
import GatheringContent from "../screen/community/GatheringContent";
import AskingBoard from "../screen/community/AskingBoard";
import GatheringBoardWrite from "../screen/community/GatheringBoardWrite";
import MamulCommunity from "../screen/community/MamulCommunity";
import MamulCommunityContent from "../screen/community/MamulCommunityContent";
import MamulCommunityWrite from "../screen/community/MamulCommunityWrite";
import FreeCommunity from "../screen/community/FreeCommunity";
import FreeCommunityContent from "../screen/community/FreeCommunityContent";
import FreeCommunityWrite from "../screen/community/FreeCommunityWrite";


import Test from "../screen/main/Test";
import Agree1 from "../screen/main/Agree1";
import Agree2 from "../screen/main/Agree2";


import consts from '../libs/consts';
import * as APIS from "../utils/service";
import { configopen } from '../redux/configSlice';
import { getMemberinfo, regPhone, patternPwCker } from "../utils/utils";
import queryString from 'query-string';
import Button from '../component/Button';
import { useropen } from '../redux/userInfo';
import moment from 'moment';
import JoinExp from '../JoinExp/joinExp';

function Routerlist() {
    const dispatch = useDispatch();
    const ckref = useRef(null);
    const location = useInRouterContext();
    const { userdata } = useSelector(state => state.userInfo);
    const [memberinfos, setmemberinfos] = useState(''); 
    const [loading, setloading] = useState(false); 
    const [viewpages, setviewpages] = useState(0); 
    const [versionpops, setversionpops] = useState(false); 

    const urlParameter = window.location.search;
    

    const query = queryString.parse(urlParameter);
    const navigate = useNavigate();


    useEffect(() => {
        window.addEventListener('click', versionCker);
        window.addEventListener('keydown', versionCker);
        // 우클릭 메뉴 차단
        window.addEventListener('contextmenu', event => event.preventDefault());
    }, []);
    let timers = null;
    const versionCker = () => {
        let token = localStorage.getItem('token');
        let logintime = localStorage.getItem('logintime');
        let checktime = moment(logintime).add(10, 'h');
        let thistime = moment();
        let diffdate = thistime.diff(checktime);
        //console.log(diffdate);
        if(diffdate > 0 && token !== ''){
            dispatch(
                useropen({
                    userdata: ""
                })
            );      
            localStorage.setItem('token', '');
            navigate('/');  
        } else {
            clearTimeout(timers);
            localStorage.setItem('logintime', moment().format('YYYY-MM-DD HH:mm:ss'));
            timers = setTimeout(() => {
                APIS.postData('/config').then(({ data }) => {
                    //console.log(data?.version, consts?.versions);
                    if(data?.version*1 !== consts?.versions*1){
                        setversionpops(true);
                    }
                }).catch((e) => {
                }).finally(() => {
                });
            }, 500);
        }

    }
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, [userdata]);
    useEffect(() => {
        console.log('locationlocation', location);
    }, [location]);

    useEffect(() => {
        console.log("memberinfos", memberinfos);
    }, [memberinfos]);

    useEffect(() => {
        APIS.postData('/config').then(({ data }) => {
            console.log(data?.loading_img);
            dispatch(
                configopen({
                    configdata: data,
                })
            );
        }).catch((e) => {
        }).finally(() => {
        });
    }, []);

    useEffect(() => {
        if(query?.token){
            setloading(true);
            setviewpages(0);
        }
        if(query?.itemtoken){
            setloading(true);
            setviewpages(1);
        }        
    }, [query]);
        
    return(
        <>
    <Routes
        ref={ckref}
    >
        {loading === true ? 
            <>
            <Route exact path={'/'} element={ viewpages === 0 ? <Customersendlist /> : <ItemDetails />  } />
            </>
        :
            <>
            {userdata?.login === true ?
                <>
                {memberinfos?.application ?
                    <>
                        {memberinfos?.compony ?
                            <>
                            <Route exact path={'/'} element={ !userdata ? <Login /> : <Main /> } />
                            <Route exact path={'/Main'} element={ !userdata ? <Login /> : <Main /> } />
                            </>
                        :
                            <>
                            <Route exact path={'/'} element={ <StoretypeFinsub /> } />
                            <Route exact path={'/Main'} element={ <StoretypeFinsub /> } />
                            </>
                        }
                    </>
                :
                    <>
                        {(memberinfos && !memberinfos?.compony) ? 
                            <>
                            {memberinfos?.level*1 === 1 ?
                                <>
                                <Route exact path={'/'} element={ <Storetype2Write /> } />
                                <Route exact path={'/Main'} element={ <Storetype2Write /> } />
                                </>
                            :
                                <>
                                <Route exact path={'/'} element={ <Storeselctor /> } />
                                <Route exact path={'/Main'} element={ <Storeselctor /> } />
                                </>
                            }
                            </>
                        :
                            <>
                            {(memberinfos?.compony?.status*1 === 1 || memberinfos?.compony?.status*1 === 99) ?
                            <>
                            <Route exact path={'/'} element={ <StoretypeFin /> } />
                            <Route exact path={'/Main'} element={ <StoretypeFin /> } />
                            </>
                            :
                            <>
                            <Route exact path={'/'} element={ !userdata ? <Login /> : <Main /> } />
                            <Route exact path={'/Main'} element={ !userdata ? <Login /> : <Main /> } />
                            </>
                            }
                            
                            </>
                            
                        }
                        
                    </>
                }
                </>
            :
                <>
                    <Route exact path={'/'} element={ <Home /> } />
                    <Route exact path={'/Main'} element={ <Login /> } />
                </>
            }


            <Route exact path={'/Login'} element={ <Login /> } />
            <Route exact path={'/Findid'} element={ <Findid /> } />
            <Route exact path={'/Findpw'} element={ <Findpw /> } />
            <Route exact path={'/Register0'} element={ <Register0 /> } />
            <Route exact path={'/Register'} element={ <Register /> } />
            <Route exact path={'/Register2'} element={ <Register2 /> } />
            <Route exact path={'/Storeselctor'} element={ <Storeselctor /> } />
            <Route exact path={'/Storetype1Write'} element={ <Storetype1Write /> } />
            <Route exact path={'/StoretypeFin'} element={ <StoretypeFin /> } />
            <Route exact path={'/StoretypeFinsub'} element={ <StoretypeFinsub /> } />
            <Route exact path={'/Storetype2Write'} element={ <Storetype2Write /> } />
            <Route exact path={'/JoinHelp'} element={ <JoinExp /> } />

            

            <Route exact path={'/Product'} element={ !userdata ? <Login /> : <Product /> } />
            <Route exact path={'/Customer'} element={ !userdata ? <Login /> : <Customer /> } />
            <Route exact path={'/Schedules'} element={ !userdata ? <Login /> : <Schedules /> } />
            <Route exact path={'/Contract'} element={ !userdata ? <Login /> : <Contract /> } />
            <Route exact path={'/Outsidelist'} element={ !userdata ? <Login /> : <Outsidelist /> } />
            
            {/* 커뮤니티 */}
            <Route path={'/FreeCommunity'} element={!userdata ? <Login /> : <FreeCommunity />} />
            <Route path={'/FreeCommunityContent'} element={!userdata ? <Login /> : <FreeCommunityContent />} />
            <Route path={'/FreeCommunityWrite'} element={!userdata ? <Login /> : <FreeCommunityWrite />} />
            <Route path={'/Gatheringboard'} element={!userdata ? <Login /> : <GatheringBoard />} />
            <Route path={'/Gatheringcontent'} element={!userdata ? <Login /> : <GatheringContent />} />
            <Route path={'/GatheringBoardWrite'} element={!userdata ? <Login /> : <GatheringBoardWrite />} />

            {/* 커뮤니티 사용안함 */}
            {/* <Route path={'/AskingBoard'} element={<AskingBoard />} /> 
            <Route path={'/Asking'} element={<Asking />} />
            <Route path={'/AskingContent'} element={<AskingContent />} />
            <Route path={'/Jobsearchofferboard'} element={<JobSearchOfferBoard />} />
            <Route path={'/Joboffer'} element={<JobOffer />} />
            <Route path={'/Jobboardcontent'} element={<JobBoardContent />} />
            <Route path={'/Officesalesboard'} element={<OfficeSalesBoard />} />
            <Route path={'/Officesaleswrite'} element={<OfficeSalesWrite />} />
            <Route path={'/Officesalesdetail'} element={<OfficeSalesDetail />} />
            <Route path={'/Locationcommunity'} element={<LocationCommunity />} />
            <Route path={'/Locationcommunitywrite'} element={<LocationCommunityWrite />} />
            <Route path={'/Locationcommunitycontent'} element={<LocationCommunityContent />} />
            <Route path={'/MamulCommunity'} element={<MamulCommunity />} />
            <Route path={'/MamulCommunityContent'} element={<MamulCommunityContent />} />
            <Route path={'/MamulCommunityWrite'} element={<MamulCommunityWrite />} /> */}
            
            <Route exact path={'/Mypage'} element={ !userdata ? <Login /> : <Mypage /> } />
            <Route exact path={'/Abortpage'} element={ !userdata ? <Login /> : <Abortpage /> } />
            <Route exact path={'/Favoritpage'} element={ !userdata ? <Login /> : <Favoritpage /> } />
            <Route exact path={'/Blacklists'} element={ !userdata ? <Login /> : <Blacklists /> } />
            <Route exact path={'/ApplicationList'} element={ !userdata ? <Login /> : <ApplicationList /> } />
            <Route exact path={'/CompanyNotice'} element={ !userdata ? <Login /> : <CompanyNotice /> } />
            <Route exact path={'/CompanyInfo'} element={ !userdata ? <Login /> : <CompanyInfo /> } />
            <Route exact path={'/CompanyCalc'} element={ !userdata ? <Login /> : <CompanyCalc /> } />
            <Route exact path={'/CompanyworkEnd'} element={ !userdata ? <Login /> : <CompanyworkEnd /> } />
            <Route exact path={'/Membercontrol'} element={ !userdata ? <Login /> : <Membercontrol /> } />
            <Route exact path={'/Contactus'} element={ !userdata ? <Login /> : <Contactus /> } />
            <Route exact path={'/Deletelist'} element={ !userdata ? <Login /> : <Deletelist /> } />
            <Route exact path={'/Setminihome'} element={ !userdata ? <Login /> : <Setminihome /> } />
            <Route exact path={'/Workstat'} element={ !userdata ? <Login /> : <Workstat /> } />
            <Route exact path={'/Workstatceo'} element={ !userdata ? <Login /> : <Workstatceo /> } />
            <Route exact path={'/Setoutside'} element={ !userdata ? <Login /> : <Setoutside /> } />

            
            <Route exact path={'/Noticelist'} element={ !userdata ? <Login /> : <Noticelist /> } />
            <Route exact path={'/NoticeDetail'} element={ !userdata ? <Login /> : <NoticeDetail /> } />
            <Route exact path={'/Faqlist'} element={ !userdata ? <Login /> : <Faqlist /> } />
            <Route exact path={'/Useguidelist'} element={ <Useguidelist /> } />
            <Route exact path={'/UseguidelistV'} element={ <UseguidelistV /> } />
            <Route exact path={'/UseguideDetail'} element={ <UseguideDetail /> } />
            <Route exact path={'/UseguideDetailV'} element={ <UseguideDetailV /> } />
            
            <Route exact path={'/ReviewPage'} element={ !userdata ? <Login /> : <ReviewPage /> } />

            <Route exact path={'/Test'} element={ <Test /> } />
            
            <Route exact path={'/Agree1'} element={ <Agree1 /> } />
            <Route exact path={'/Agree2'} element={ <Agree2 /> } />

            <Route exact path={'*'} element={ <MiniPage /> } />

            </>
        }


    </Routes>
    {versionpops === true &&
    <div className='PopupArea'>
        <div>
            <div className='PopupAreaBG' 
                //onClick={() => { setpopflag(false); }}
            />
            <div className='PopupAreaContents'>
                <div>
                    <div className="popTitle padding20">
                        <span >알림</span>
                    </div>
                    <div className="padding32">
                        <div className='popcontents'>
                            <div style={{ width: '100%' }}>
                                <div>
                                    버전이 변경되었습니다.<br />
                                    새로고침해 주시거나 확인버튼을 눌러주세요.
                                </div>
                            </div>
                        </div>
                        
                        <div className='popbuttons'>
                            <div>
                                <Button
                                    buttonTxt={'확인'}
                                    onPress={() => { 
                                        window.location.reload();
                                    }}
                                />                                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>}
    </>
    );
}

export default Routerlist;